// extracted by mini-css-extract-plugin
module.exports = {"content-section":"Paragraph_content-section__3AEA3","title":"Paragraph_title__1PhMD","content":"Paragraph_content__3jjG-"};